import RepTabulatorController from './rep-tabulator.controller';
import RepTabulatorTpl from './rep-tabulator.tpl.html';

export default {
	template: RepTabulatorTpl,
	controller: RepTabulatorController,
	bindings: {
		dataset: '='
	}
};
